import React from "react";
import Container from "../layout/Container";
import { TfiAngleRight } from "react-icons/tfi";
import { BsPlusLg } from "react-icons/bs";
import { FiMinus } from "react-icons/fi";
import { Link } from "react-router-dom";

const MapLocation = () => {
  return (
    <div>
      <Container>
        <div className="mt-2 h-[238px] w-[551px] rounded border border-solid border-darkGreen border-opacity-30">
          <div className="py-4 px-5 ">
            <div className="flex w-full items-center justify-between">
              <h5 className="font-pop text-xl font-bold text-primary">
                Map Location
              </h5>
              <Link className="flex items-center gap-x-2" to="#">
                <p className="font-regular font-pop text-sm text-primary">
                  See Location
                </p>
                <TfiAngleRight />
              </Link>
            </div>
            <p className="font-regular mt-1.5 font-pop text-xs text-darkGreen text-opacity-60">
              Eastern Cape Jeffrey’s Bay
            </p>
            <div className="relative mt-3 h-[136px] w-[509px] rounded">
              <img src="assets/images/auction_listing/map.png" alt="map" />
              <div className="absolute top-2.5 left-2.5 flex flex-col">
                <button className="mb-1 bg-white py-1 px-1">
                  <BsPlusLg />
                </button>
                <button className="bg-white py-1 px-1">
                  <FiMinus />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="flex w-full items-center justify-between">
          <h5 className="font-pop text-sm font-bold text-darkGreen">
            Ad id 1062795441
          </h5>
          <p className="font-pop text-xs font-bold text-darkGreen">
            Report this ad
          </p>
        </div>
      </Container>
    </div>
  );
};

export default MapLocation;
